import * as tslib_1 from "tslib";
import styled, { withProps } from '../styles';
/**@ReactComponent
 *
 * 表格
 */
var Table = withProps()(styled.table)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n"], ["\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n"])));
export default Table;
var templateObject_1;
//# sourceMappingURL=Table.js.map